import { render, staticRenderFns } from "./IndicatorRelationshipPopup.vue?vue&type=template&id=f5d65acc&scoped=true"
import script from "./IndicatorRelationshipPopup.vue?vue&type=script&lang=js"
export * from "./IndicatorRelationshipPopup.vue?vue&type=script&lang=js"
import style0 from "./IndicatorRelationshipPopup.vue?vue&type=style&index=0&id=f5d65acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d65acc",
  null
  
)

export default component.exports